import React from 'react';
import { motion } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Download, Eye } from 'lucide-react';
const notices = [{
  title: 'Admission Notice for Academic Year 2026',
  date: 'March 10, 2026',
  category: 'Admission',
  description: 'Applications are now open for admission to all classes for the academic year 2026'
}, {
  title: 'Annual Examination Schedule Published',
  date: 'March 8, 2026',
  category: 'Examination',
  description: 'Final examination schedule for all classes has been published on the notice board'
}, {
  title: 'Holiday Notice - Eid-ul-Fitr',
  date: 'March 5, 2026',
  category: 'Holiday',
  description: 'School will remain closed from April 10-20 for Eid-ul-Fitr holidays'
}, {
  title: 'Parent-Teacher Meeting Circular',
  date: 'March 1, 2026',
  category: 'Meeting',
  description: 'Quarterly parent-teacher meeting scheduled for March 15, 2026'
}, {
  title: 'Science Fair Registration Open',
  date: 'February 28, 2026',
  category: 'Event',
  description: 'Students can register for the annual science fair until March 20'
}];
export function NoticeBoard() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section id="notice" className="py-20 bg-white" data-id="element-235">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
        <div className="text-center mb-16" data-id="element-237">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-text-dark mb-4" data-id="element-238">
            Notice Board
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto mb-4" data-id="element-239"></div>
          <p className="text-lg text-text-muted max-w-2xl mx-auto" data-id="element-240">
            Important announcements and updates
          </p>
        </div>

        <div ref={ref} className="space-y-4" data-id="element-241">
          {notices.map((notice, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} animate={isVisible ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-white border border-gray-200 rounded-lg p-6 shadow-md hover:shadow-lg transition-all" data-id="element-242">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-243">
                <div className="flex-1" data-id="element-244">
                  <div className="flex items-center gap-3 mb-2" data-id="element-245">
                    <span className="bg-primary/10 text-primary px-3 py-1 rounded-full text-xs font-semibold" data-id="element-246">
                      {notice.category}
                    </span>
                    <span className="text-sm text-text-muted" data-id="element-247">
                      {notice.date}
                    </span>
                  </div>
                  <h3 className="text-xl font-heading font-semibold text-text-dark mb-2" data-id="element-248">
                    {notice.title}
                  </h3>
                  <p className="text-text-muted" data-id="element-249">{notice.description}</p>
                </div>
                <div className="flex gap-2" data-id="element-250">
                  <button className="flex items-center gap-2 bg-primary hover:bg-primary-dark text-white px-4 py-2 rounded-md transition-colors" data-id="element-251">
                    <Eye size={18} data-id="element-252" />
                    <span className="text-sm font-medium" data-id="element-253">View</span>
                  </button>
                  <button className="flex items-center gap-2 bg-gold hover:bg-gold/90 text-white px-4 py-2 rounded-md transition-colors" data-id="element-254">
                    <Download size={18} data-id="element-255" />
                    <span className="text-sm font-medium" data-id="element-256">Download</span>
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}